<template>
  <div class="local-space" v-loading="initialLoading" element-loading-text="正在加载文件列表..." element-loading-background="rgba(0, 0, 0, 0.7)">
    <!-- 顶部提示条 -->
    <div class="notice-bar">
      <i class="fa-solid fa-triangle-exclamation notice-icon"></i>
      <span>所有任务产生的结果，都会存放在云盘空间，请及时下载，文件将在7天后自动删除！每个用户有100MB的免费空间，如空间不足，会导致任务执行失败，可以申请扩容。</span>
    </div>

    <!-- 主内容区域：左右分区 -->
    <div class="cloud-container">
      <div class="storage-panel">
        <div class="storage-status">
          <div class="storage-text">
            <span>可用空间:</span>
            <span><strong>{{ formatGB(usedQuota) }}</strong> / {{ formatGB(totalQuota) }}</span>
          </div>
          <div class="progress-track">
            <div class="progress-fill" :style="{ width: percent + '%' }"></div>
          </div>
          <div class="storage-actions">
            <a href="#" class="action-link" @click.prevent="openExpandDialog"><i class="fa-solid fa-bolt"></i> 扩容</a>
            <a href="#" class="action-link" @click.prevent="openRenewDialog"><i class="fa-solid fa-file-contract"></i> 续签</a>
          </div>
        </div>

        <div style="font-size: 12px; color: #9CA3AF; margin-bottom: 8px;">我的文件夹</div>
        <div class="folder-list">
          <div v-if="folderList.length === 0" class="empty-folder">
            <el-icon :size="100" color="#9CA3AF"><Folder /></el-icon>
            <div class="empty-text">暂无文件夹</div>
          </div>
          <el-tree
          v-else
          :data="folderList"
          :props="treeProps"
          node-key="id"
          default-expand-all
          highlight-current
          @node-click="handleNodeClick"
          @node-contextmenu="handleNodeContextmenu"
          style="margin-top: 10px; color: #1F2937;"
          class="drop-target-tree"
        >
          <template #default="{ node, data }">
            <span 
              class="folder-tree-node"
              @mouseenter="handleNodeMouseEnter($event, data)"
              @mouseleave="handleNodeMouseLeave"
            >
              <i class="fa-regular folder-tree-icon" :class="selectedNode && selectedNode.id === data.id ? 'fa-folder-open' : 'fa-folder'"></i>
              <span class="folder-tree-details">
                <span class="folder-tree-name" :title="data.folderName">{{ data.folderName }}</span>
                <span class="folder-tree-size">{{ formatSize(data.folderSize) }}</span>
              </span>
              
              <!-- 悬浮操作菜单 -->
              <div 
                v-if="hoveredNodeId === data.id && hoverMenuPosition"
                class="folder-hover-menu"
                :style="hoverMenuPosition"
                @mouseenter="handleMenuMouseEnter"
                @mouseleave="handleMenuMouseLeave"
              >
                <div 
                  class="hover-menu-item"
                  @click.stop="openUploadDialogForNode(data)"
                  title="上传文件"
                >
                  <i class="fa-solid fa-upload"></i>
                  <span>上传</span>
                </div>
                <div 
                  class="hover-menu-item"
                  @click.stop="openAddChildDialog(data)"
                  title="新建子文件夹"
                >
                  <i class="fa-solid fa-plus"></i>
                  <span>新建</span>
                </div>
                <div 
                  v-if="!isRootNode(data)"
                  class="hover-menu-item"
                  @click.stop="handleDeleteFolder(data)"
                  title="删除文件夹"
                >
                  <i class="fa-regular fa-trash-can"></i>
                  <span>删除</span>
                </div>
                <div 
                  class="hover-menu-item"
                  @click.stop="openEditFolderDialog(data)"
                  title="编辑文件夹"
                >
                  <i class="fa-regular fa-pen-to-square"></i>
                  <span>编辑</span>
                </div>
              </div>
              
              <!-- <span style="font-size: 13px; color: #ccc;">排序: {{ data.folderSort }}</span>
              <span style="font-size: 13px; color: #ccc;">{{ formatDate(data.createDate) }}</span> -->
            </span>
          </template>
        </el-tree>
        <div v-if="contextMenuVisible" :style="contextMenuStyle" class="context-menu" @click="handleClickOutsideMenu">
          <div class="context-menu-item" @click.stop="handleAddChildFolder">新建子文件夹</div>
        </div>
      </div>
      </div>
      <div class="file-browser">
        <div class="browser-toolbar">
          <div class="toolbar-left">
            <el-checkbox 
              :model-value="isAllSelected" 
              @change="handleSelectAll"
            >
              全选
            </el-checkbox>
          </div>
          <div class="toolbar-right">
            <el-button type="danger" @click="handleBatchDelete" :disabled="multipleSelection.length==0" size="default">批量删除</el-button>
            <el-button @click="handleBatchDownload" :disabled="multipleSelection.length==0" size="default">批量下载</el-button>
            <el-button @click="openBatchMoveDialog" :disabled="multipleSelection.length==0" size="default">批量修改文件夹</el-button>
          </div>
        </div>
        
        <div class="file-grid-scroll">
            <!-- 骨架屏 -->
            <div v-if="loading" class="file-card-grid">
              <el-card
                v-for="n in pageSize"
                :key="`skeleton-${n}`"
                class="file-card skeleton-card"
              >
                <el-skeleton :loading="true" animated>
                  <template #template>
                    <div class="skeleton-thumbnail"></div>
                    <div class="skeleton-content">
                      <el-skeleton-item variant="text" style="width: 60%; margin-bottom: 12px;" />
                      <el-skeleton-item variant="text" style="width: 40%; margin-bottom: 8px;" />
                      <el-skeleton-item variant="text" style="width: 50%;" />
                    </div>
                    <div class="skeleton-actions">
                      <el-skeleton-item variant="button" style="width: 60px; margin-right: 8px;" />
                      <el-skeleton-item variant="button" style="width: 60px; margin-right: 8px;" />
                      <el-skeleton-item variant="button" style="width: 60px; margin-right: 8px;" />
                      <el-skeleton-item variant="button" style="width: 60px;" />
                    </div>
                  </template>
                </el-skeleton>
              </el-card>
            </div>
            <!-- 空状态 -->
            <div v-else-if="fileList.length === 0" class="empty-file-list">
              <el-icon :size="80" color="#666"><Document /></el-icon>
              <div class="empty-text">暂无文件</div>
            </div>
            <!-- 实际内容 -->
            <div v-else class="file-card-grid">
              <div
                v-for="file in fileList"
                :key="file.id"
                class="file-card"
                :class="{ 'file-card-selected': isFileSelected(file) }"
              >
                <!-- 预览区域 -->
                <div 
                  class="file-preview"
                  :class="{ 
                    'placeholder': (getFileType(file) !== 'audio' && getFileType(file) !== 'video' && (!isImageFile(file) || !file.fileUrl)) || (getFileType(file) === 'video' && !file.fileUrl),
                    'audio': getFileType(file) === 'audio'
                  }"
                  @click="handleThumbnailClick(file)"
                >
                  <!-- 选择框 -->
                  <input 
                    type="checkbox" 
                    class="card-checkbox"
                    :checked="isFileSelected(file)"
                    @click.stop
                    @change="toggleFileSelection(file, $event.target.checked)"
                  />
                  
                  <!-- 下载遮罩按钮 -->
                  <div 
                    class="download-overlay" 
                    @click.stop="handleDownloadFile(file)"
                    title="下载"
                  >
                    <i class="fa-solid fa-download"></i>
                  </div>
                  
                  <!-- 图片，加载成功时覆盖图标 -->
                  <img
                    v-if="isImageFile(file) && file.fileUrl"
                    :src="file.fileUrl"
                    :alt="file.fileName"
                    @error="handleImageError"
                    @load="handleImageLoad"
                  />
                  
                  <!-- 视频缩略图 -->
                  <video
                    v-else-if="getFileType(file) === 'video' && file.fileUrl"
                    :ref="el => setVideoRef(el, file.id)"
                    :src="file.fileUrl"
                    :preload="getVideoPreload(file.id)"
                    muted
                    playsinline
                    @error="handleVideoError($event, file)"
                    @loadedmetadata="handleVideoLoadedMetadata($event, file)"
                    @loadeddata="handleVideoLoadedData($event, file)"
                    @canplay="handleVideoCanPlay($event, file)"
                    crossorigin="anonymous"
                  />
                  
                  <!-- 音频波形图 -->
                  <img
                    v-else-if="getFileType(file) === 'audio'"
                    :src="waveImage"
                    alt="audio preview"
                  />
                  
                  <!-- 播放按钮（仅音频和视频文件显示） -->
                  <i 
                    v-if="getFileType(file) === 'audio' || getFileType(file) === 'video'"
                    class="fa-regular fa-circle-play play-overlay"
                    @click.stop="openPreview(file)"
                  ></i>
                </div>
                
                <!-- 文件信息区域 -->
                <div class="file-info">
                  <!-- 文件名 -->
                  <div class="file-name" :title="file.fileName">
                    <i :class="getFileIconClass(file)"></i>
                    <span>{{ file.fileName }}</span>
                  </div>
                  
                  <!-- 元数据列表 -->
                  <div class="meta-list">
                    <div class="meta-item">
                      <i class="fa-solid fa-database"></i>
                      <span>{{ formatSize(file.fileSize) }}</span>
                    </div>
                    <div v-if="file.remark" class="meta-item" :title="file.remark">
                      <i class="fa-solid fa-tag"></i>
                      <span>{{ file.remark }}</span>
                    </div>
                    <div class="meta-item">
                      <i class="fa-regular fa-clock"></i>
                      <span>{{ formatDate(file.createDate) }}</span>
                    </div>
                  </div>
                </div>
                
                <!-- 操作按钮区域 -->
                <div class="card-actions">
                  <div class="action-group">
                    <i 
                      class="fa-regular fa-pen-to-square icon-btn" 
                      title="重命名/移动"
                      @click.stop="openRenameDialog(file)"
                    ></i>
                    <i 
                      class="fa-regular fa-trash-can icon-btn delete" 
                      title="删除"
                      @click.stop="handleDeleteFile(file)"
                    ></i>
                    <i 
                      class="fa-solid fa-folder-tree icon-btn" 
                      title="移动"
                      @click.stop="openRenameDialog(file)"
                    ></i>
                    <i 
                    class="fa-solid fa-download icon-btn" 
                    title="下载"
                    @click.stop="handleDownloadFile(file)"
                  ></i>
                  </div>
                  <div 
                      class="toggle-switch"
                      :class="{ 'active': file.sign === 1 }"
                      @click.stop="handleSignChange(file, file.sign !== 1)"
                      title="永久保留"
                    ></div>
                </div>
              </div>
            </div>
        </div>

        <!-- 分页组件 -->
        <Pagination
          :total="total"
          :current-page="currentPage"
          :page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          @page-change="handlePageChange"
          @size-change="handlePageSizeChange"
        />
      </div>
    </div>
    <el-dialog v-model="addDialogVisible" title="新建文件夹" width="400px" :close-on-click-modal="false">
      <template v-if="selectedNode">
        <div style="margin-bottom: 8px; color: #888;">父文件夹：{{ selectedNode.folderName }}</div>
      </template>
      <template v-else>
        <div style="margin-bottom: 8px; color: #888;">父文件夹：根目录</div>
      </template>
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="140px">
        <el-form-item label="文件夹名称" prop="folderName">
          <el-input v-model="addForm.folderName" maxlength="32" show-word-limit />
        </el-form-item>
        <el-form-item label="排序" prop="folderSort">
          <el-input-number v-model="addForm.folderSort" :min="1" :max="9999" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="addFormLoading" @click="handleAddFolder">确定</el-button>
      </template>
    </el-dialog>
    <el-dialog v-model="renameDialogVisible" title="文件操作" width="500px" :close-on-click-modal="false">
      <el-form :model="renameForm" label-width="100px">
        <el-form-item label="新文件名" prop="fileName">
          <el-input v-model="renameForm.fileName" maxlength="128" show-word-limit />
        </el-form-item>
        <el-form-item label="所属文件夹" prop="targetFolderId">
          <el-tree-select
            v-model="renameForm.targetFolderId"
            :data="folderList"
            :props="treeProps"
            node-key="id"
            placeholder="选择目标文件夹"
            check-strictly
            :render-after-expand="false"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="renameDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="renameLoading" @click="handleRenameFile">确定</el-button>
      </template>
    </el-dialog>
    <el-dialog v-model="batchMoveDialogVisible" title="批量修改文件夹" width="500px" :close-on-click-modal="false">
      <div style="margin-bottom: 16px; color: #666;">
        已选择 {{ multipleSelection.length }} 个文件
      </div>
      <el-form :model="batchMoveForm" label-width="100px">
        <el-form-item label="目标文件夹" prop="targetFolderId">
          <el-tree-select
            v-model="batchMoveForm.targetFolderId"
            :data="folderList"
            :props="treeProps"
            node-key="id"
            placeholder="选择目标文件夹"
            check-strictly
            :render-after-expand="false"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="batchMoveDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="batchMoveLoading" @click="handleBatchMoveFiles">确定</el-button>
      </template>
    </el-dialog>
    <el-dialog v-model="uploadDialogVisible" title="本地上传" width="400px" :close-on-click-modal="false">
      <el-upload
        v-model:file-list="uploadFileList"
        :limit="1"
        :auto-upload="false"
        :show-file-list="true"
        :before-upload="() => false"
        drag
      >
        <el-icon class="el-icon--upload"><upload-filled /></el-icon>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <template #footer>
        <el-button @click="uploadDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="uploadLoading" @click="handleUploadFile">上传</el-button>
      </template>
    </el-dialog>
    <el-dialog v-model="editFolderDialogVisible" title="修改文件夹名称" width="400px" :close-on-click-modal="false">
      <el-form :model="editFolderForm" label-width="90px">
        <el-form-item label="新名称" prop="folderName">
          <el-input v-model="editFolderForm.folderName" maxlength="32" show-word-limit />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="editFolderDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="editFolderLoading" @click="handleEditFolder">确定</el-button>
      </template>
    </el-dialog>
    <!-- 扩容弹窗 -->
    <el-dialog v-model="expandDialogVisible" title="存储空间扩容" width="500px" :close-on-click-modal="false">
      <div class="expand-content">
        <div class="expand-info">         
          <div class="expand-input-area">
            <el-form :model="expandForm" :rules="expandFormRules" ref="expandFormRef" label-width="120px">
              <el-form-item label="当前空间">
                <span>{{ formatGB(usedQuota) }} / {{ formatGB(totalQuota) }}</span>
              </el-form-item>
              <el-form-item label="有效期">
                <span>{{ validityPeriod }}</span>
              </el-form-item>
              <el-form-item label="扩容容量" prop="expandSize">
                <el-input-number 
                  v-model="expandForm.expandSize" 
                  :min="100" 
                  :max="10000" 
                  :step="100"
                  placeholder="请输入扩容容量"
                  style="width: 200px;"
                >
                  <template #suffix>
                    <span>MB</span>
                  </template>
                </el-input-number>
                <div class="expand-tip">最小100MB，只能输入100MB的倍数</div>
              </el-form-item>
              
              <el-form-item label="扩容费用" prop="expandPrice">
                <div class="price-display">
                  <el-text class="expand-price">￥{{ expandForm.expandPrice }}</el-text>
                  <el-text v-if="expandForm.originalPrice !== expandForm.expandPrice" class="original-price">原价：￥{{ expandForm.originalPrice }}</el-text>
                </div>
              </el-form-item>
              <el-form-item label="支付方式" prop="payMethod">
                <el-radio-group v-model="expandForm.payMethod">
                  <el-radio label="alipay">支付宝</el-radio>
                  <el-radio label="wechat">微信</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <template #footer>
        <el-button @click="expandDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="expandLoading" @click="handleExpandConfirm">确认扩容</el-button>
      </template>
    </el-dialog>
    
    <!-- 续签弹窗 -->
    <el-dialog v-model="renewDialogVisible" title="存储空间续签" width="500px" :close-on-click-modal="false">
      <div class="renew-content">
        <div class="renew-info">
          <div class="current-space">
            <span>当前空间：{{ formatGB(usedQuota) }} / {{ formatGB(totalQuota) }}</span>
          </div>
          <div class="current-vip">
            <span>当前VIP到期：{{ currentVipExpireTime }}</span>
            <span style="margin-left: 24px; color: #11c9d6;">续签后到期：{{ renewAfterExpireTime }}</span>
          </div>
          <div class="renew-input-area">
            <el-form :model="renewForm" :rules="renewFormRules" ref="renewFormRef" label-width="120px">
              <el-form-item label="续签时长" prop="renewYears">
                <el-input-number 
                  v-model="renewForm.renewYears" 
                  :min="1" 
                  :max="10" 
                  :step="1"
                  placeholder="请输入续签年数"
                  style="width: 200px;"
                >
                  <template #suffix>
                    <span>年</span>
                  </template>
                </el-input-number>
                <div class="renew-tip">续签后VIP到期时间将延长相应年数</div>
              </el-form-item>
              <el-form-item label="续签容量" prop="renewSize">
                <el-input-number
                  v-model="renewForm.renewSize"
                  :min="100"
                  :max="totalQuota"
                  :step="100"
                  style="width: 200px;"
                >
                  <template #suffix>
                    <span>MB</span>
                  </template>
                </el-input-number>
                <div class="renew-tip">不能大于当前容量，可降档</div>
              </el-form-item>
              <el-form-item label="续签费用" prop="renewPrice">
                <div class="price-display">
                  <el-text v-if="Number(renewForm.renewPrice) !== Number(renewForm.originalPrice)" class="original-price">原价：￥{{ renewForm.originalPrice }}</el-text>
                  <el-text class="renew-price">￥{{ renewForm.renewPrice }}</el-text>
                </div>
                <div class="renew-tip">续签费用：(续签容量-100M)÷10×续签年数，2年9折，3年8折，4年7折，5年以上6折</div>
              </el-form-item>
              <el-form-item label="支付方式" prop="payMethod">
                <el-radio-group v-model="renewForm.payMethod">
                  <el-radio label="alipay">支付宝</el-radio>
                  <el-radio label="wechat">微信</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <template #footer>
        <el-button @click="renewDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="renewLoading" @click="handleRenewConfirm">确认续签</el-button>
      </template>
    </el-dialog>
    
    <!-- 文件预览弹窗 -->
    <el-dialog 
      v-model="previewDialogVisible" 
      :title="previewFile ? `预览 - ${previewFile.fileName}` : '文件预览'" 
      width="600px" 
      :close-on-click-modal="false" 
      center
      @close="previewFile = null; previewType = ''"
    >
      <div v-if="previewFile" class="preview-content">
        <!-- 音频预览 -->
        <div v-if="previewType === 'audio'" class="audio-preview">
          <div class="preview-info">
            <div class="file-name">{{ previewFile.fileName }}</div>
            <div class="file-size">{{ formatSize(previewFile.fileSize) }}</div>
          </div>
          <audio 
            :src="previewFile.fileUrl" 
            controls 
            preload="metadata"
            style="width: 100%; margin-top: 16px;"
          >
            您的浏览器不支持音频播放。
          </audio>
        </div>
        
        <!-- 视频预览 -->
        <div v-else-if="previewType === 'video'" class="video-preview">
          <div class="preview-info">
            <div class="file-name">{{ previewFile.fileName }}</div>
            <div class="file-size">{{ formatSize(previewFile.fileSize) }}</div>
          </div>
          <video 
            :src="previewFile.fileUrl" 
            controls 
            preload="metadata"
            style="width: 100%; max-height: 400px; margin-top: 16px;"
          >
            您的浏览器不支持视频播放。
          </video>
        </div>
      </div>
      
      <template #footer>
        <el-button @click="previewDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="handleDownloadFile(previewFile)" v-if="previewFile">
          <el-icon><Download /></el-icon>
          下载文件
        </el-button>
      </template>
    </el-dialog>
    
    <!-- 支付弹窗 -->
    <el-dialog v-model="showPayModal" title="扫码支付" width="480px" :close-on-click-modal="false" :show-close="true" center style="background: #3b3b3b;" @close="stopPaymentPolling">
      <div class="pay-modal">
        <div class="pay-order">
          <img v-if="payMethod === 'wechat' && payQRCode" :src="payQRCode" alt="微信二维码" class="pay-qrcode" />
          <div v-if="payMethod === 'wechat'">
            <div class="pay-info">
              <div>订单编号：{{ currentOrderId }}</div>
              <div v-if="payType === 'expand'">扩容容量：{{ expandForm.expandSize }}MB</div>
              <div v-if="payType === 'renew'">续签容量：{{ renewForm.renewSize }}MB</div>
              <div v-if="payType === 'renew'">续签年数：{{ renewForm.renewYears }}年</div>
              <div>支付方式：微信</div>
              <div class="pay-amount">
                订单金额：
                <span style="color:#ffd700;font-size:22px;">
                  ￥{{ payType === 'expand' ? expandForm.expandPrice : renewForm.renewPrice }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="pay-tip" v-if="payMethod === 'wechat'">【温馨提示】：存储空间服务购买后不可退款。</div>
      </div>
    </el-dialog>
    <PaymentUnavailableDialog v-model="showPaymentUnavailable" />
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, watch, computed } from 'vue'
import { useUserStore } from '@/stores/portal/user'
import { getUserFolderList, addUserFolder, deleteUserFolder, getFilesByFolder, downloadUserFile, deleteUserFile, renameUserFile, moveUserFile, batchMoveUserFiles, batchDeleteUserFiles, batchDownloadUserFiles, uploadUserFile, renameUserFolder, updateFileSign } from '@/api/portal/user'
import { createExpandOrder, createRenewOrder, getWxPayParams, getAlipayParams, queryWxPayOrder, queryAlipayOrder } from '@/api/portal/order'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Plus, Delete, UploadFilled, Edit, VideoPlay, Film, Headset, Document, Download, Clock, DocumentCopy } from '@element-plus/icons-vue'
import QRCode from 'qrcode'
import { useRouter } from 'vue-router'
import waveImage from '@/apps/portal/assets/wave.png'
import Pagination from '@/apps/portal/components/Pagination.vue'
import PaymentUnavailableDialog from '@/apps/portal/components/PaymentUnavailableDialog.vue'

const userStore = useUserStore()
const router = useRouter()
const showPaymentUnavailable = ref(false)

function blockUnavailablePayment() {
  showPaymentUnavailable.value = true
  return true
}
const totalQuota = ref(0)
const usedQuota = ref(0)
const percent = ref(0)
const folderList = ref([])
const fileList = ref([])
const currentFolderId = ref(null)
const hoveredNodeId = ref(null)
const hoverMenuPosition = ref(null)

// 分页相关
const currentPage = ref(1)
const pageSize = ref(50)
const total = ref(0)
const loading = ref(false)
const initialLoading = ref(false) // 首次加载状态

// 视频懒加载相关
const videoRefs = new Map()
const loadedVideos = ref(new Set())
let videoObserver = null

// 初始化视频 Intersection Observer
const initVideoObserver = () => {
  if (videoObserver) {
    return
  }
  
  videoObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const videoId = entry.target.dataset.videoId
        if (videoId && !loadedVideos.value.has(videoId)) {
          loadedVideos.value.add(videoId)
          const video = entry.target
          if (video) {
            // 设置为auto以加载第一帧
            video.preload = 'auto'
            // 确保定位到第一帧
            video.currentTime = 0.1 // 设置为0.1秒，避免某些视频第一帧是黑屏
          }
        }
      }
    })
  }, {
    rootMargin: '50px' // 提前50px开始加载
  })
}

// 设置视频引用
const setVideoRef = (el, fileId) => {
  if (el && fileId) {
    el.dataset.videoId = fileId
    videoRefs.set(fileId, el)
    
    // 初始化 Observer
    if (!videoObserver) {
      initVideoObserver()
    }
    
    // 观察视频元素
    if (videoObserver) {
      videoObserver.observe(el)
    }
  }
}

// 获取视频 preload 值
const getVideoPreload = (fileId) => {
  // 如果视频已经进入视口，使用auto以加载第一帧
  return loadedVideos.value.has(fileId) ? 'auto' : 'none'
}

// 处理视频加载错误
const handleVideoError = (event, file) => {
  const video = event.target
  console.error('[LocalSpace] 视频加载失败:', {
    fileId: file.id,
    fileUrl: file.fileUrl,
    error: video.error ? {
      code: video.error.code,
      message: video.error.message
    } : null,
    networkState: video.networkState,
    readyState: video.readyState
  })
  
  // 如果视频加载失败，可能是Content-Disposition设置为attachment导致的
  // 建议在腾讯云COS控制台将Content-Disposition改为inline
  if (video.error && video.error.code === MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED) {
    console.warn('[LocalSpace] 视频格式不支持或Content-Type/Content-Disposition配置错误')
    console.warn('[LocalSpace] 建议检查：1. Content-Type是否为video/mp4 2. Content-Disposition是否为inline（不是attachment）')
  }
}

// 处理视频元数据加载成功
const handleVideoLoadedMetadata = (event, file) => {
  const video = event.target
  //console.log('[LocalSpace] 视频元数据加载成功:', {
  //  fileId: file.id,
  //  videoWidth: video.videoWidth,
  //  videoHeight: video.videoHeight,
  //  duration: video.duration
  //})
  
  // 确保定位到第一帧（0.1秒，避免某些视频第一帧是黑屏）
  if (video.readyState >= 1) { // HAVE_METADATA
    video.currentTime = 0.1
  }
}

// 处理视频第一帧数据加载成功
const handleVideoLoadedData = (event, file) => {
  const video = event.target
  //console.log('[LocalSpace] 视频第一帧数据加载成功:', {
  //  fileId: file.id,
  //  currentTime: video.currentTime,
  //  readyState: video.readyState
  //})
  
  // 确保定位到第一帧
  if (video.currentTime === 0 || video.currentTime < 0.1) {
    video.currentTime = 0.1
  }
}

// 处理视频可以播放
const handleVideoCanPlay = (event, file) => {
  const video = event.target
  //console.log('[LocalSpace] 视频可以播放:', {
  //  fileId: file.id,
  //  currentTime: video.currentTime,
  //  readyState: video.readyState
  //})
  
  // 确保定位到第一帧并暂停（不自动播放）
  if (video.currentTime === 0 || video.currentTime < 0.1) {
    video.currentTime = 0.1
  }
  video.pause() // 确保视频暂停，只显示第一帧
}

// 清理不再存在的视频观察
const cleanupUnusedVideoObservers = (currentFileIds) => {
  if (!videoObserver) return
  
  const currentIds = new Set(currentFileIds)
  const toRemove = []
  
  videoRefs.forEach((el, fileId) => {
    if (!currentIds.has(fileId)) {
      toRemove.push(fileId)
      videoObserver.unobserve(el)
    }
  })
  
  toRemove.forEach(fileId => {
    videoRefs.delete(fileId)
    loadedVideos.value.delete(fileId)
  })
}

// 清理视频 Observer
const cleanupVideoObserver = () => {
  if (videoObserver) {
    videoRefs.forEach((el) => {
      videoObserver.unobserve(el)
    })
    videoRefs.clear()
    loadedVideos.value.clear()
    videoObserver.disconnect()
    videoObserver = null
  }
}

const treeProps = {
  children: 'children',
  label: 'folderName'
}

const selectedNode = ref(null)
function handleNodeClick(data, node, e) {
  if (data && data.id) {
    selectedNode.value = data
    currentFolderId.value = data.id
    currentPage.value = 1 // 重置到第一页
    fetchFileList(data.id, 1, pageSize.value)
    // 自动展开/收起
    if (node && typeof node.expanded === 'boolean') {
      if (node.expanded) {
        node.collapse()
      } else {
        node.expand()
      }
    }
  }
}

// 处理节点鼠标进入事件
function handleNodeMouseEnter(event, data) {
  hoveredNodeId.value = data.id
  const target = event.currentTarget
  const rect = target.getBoundingClientRect()
  const storagePanel = target.closest('.storage-panel')
  
  // 计算菜单位置：显示在节点右侧，在 storage-panel 右侧边缘
  if (storagePanel) {
    const panelRect = storagePanel.getBoundingClientRect()
    hoverMenuPosition.value = {
      position: 'fixed',
      left: (panelRect.right + 8) + 'px',
      top: (rect.top + rect.height / 2) + 'px',
      transform: 'translateY(-50%)',
      zIndex: 1000
    }
  } else {
    hoverMenuPosition.value = {
      position: 'fixed',
      left: (rect.right + 8) + 'px',
      top: (rect.top + rect.height / 2) + 'px',
      transform: 'translateY(-50%)',
      zIndex: 1000
    }
  }
}

// 处理节点鼠标离开事件
let hideMenuTimer = null
function handleNodeMouseLeave() {
  // 延迟隐藏，以便鼠标可以移动到菜单上
  hideMenuTimer = setTimeout(() => {
    const menu = document.querySelector('.folder-hover-menu')
    if (!menu || !menu.matches(':hover')) {
      hoveredNodeId.value = null
      hoverMenuPosition.value = null
    }
  }, 150)
}

// 当鼠标进入菜单时，清除隐藏定时器
function handleMenuMouseEnter() {
  if (hideMenuTimer) {
    clearTimeout(hideMenuTimer)
    hideMenuTimer = null
  }
}

// 当鼠标离开菜单时，隐藏菜单
function handleMenuMouseLeave() {
  hoveredNodeId.value = null
  hoverMenuPosition.value = null
}

// 右键菜单相关
const contextMenuVisible = ref(false)
const contextMenuStyle = ref({})
const contextMenuNode = ref(null)

function handleNodeContextmenu(event, data, node) {
  event.preventDefault()
  contextMenuNode.value = data
  contextMenuStyle.value = {
    position: 'fixed',
    left: event.clientX + 'px',
    top: event.clientY + 'px',
    zIndex: 9999
  }
  contextMenuVisible.value = true
}

function handleAddChildFolder() {
  addForm.value = { folderName: '', folderSort: 1 }
  addDialogVisible.value = true
  selectedNode.value = contextMenuNode.value
  contextMenuVisible.value = false
}

function handleClickOutsideMenu() {
  contextMenuVisible.value = false
}

// 悬浮+号新建子文件夹
function openAddChildDialog(nodeData) {
  addForm.value = { folderName: '', folderSort: 1 }
  addDialogVisible.value = true
  selectedNode.value = nodeData
}

async function handleDeleteFolder(nodeData) {
  try {
    await ElMessageBox.confirm(
      `确定要删除文件夹"${nodeData.folderName}"吗？`,
      '提示',
      { type: 'warning' }
    )
    await deleteUserFolder(nodeData.id)
    ElMessage.success('删除成功')
    fetchFolderList()
    if (selectedNode.value && selectedNode.value.id === nodeData.id) {
      selectedNode.value = null
    }
  } catch (e) {
    if (e !== 'cancel' && e !== 'close') {
      ElMessage.error(e.message || '删除失败')
    }
  }
}

function formatGB(bytes) {
  // 后端返回的单位是MB，需要转换为GB显示
  return (bytes / 1024).toFixed(2) + 'GB'
}

function formatSize(bytes) {
  if (!bytes) return '0B'
  if (bytes >= 1024 * 1024 * 1024) {
    return (bytes / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
  } else if (bytes >= 1024 * 1024) {
    return (bytes / (1024 * 1024)).toFixed(2) + 'MB'
  } else if (bytes >= 1024) {
    return (bytes / 1024).toFixed(2) + 'KB'
  }
  return bytes + 'B'
}

function formatDate(dateStr) {
  if (!dateStr) return ''
  const d = new Date(dateStr)
  return d.toLocaleString()
}

async function fetchUserSpace() {
  const userInfo = await userStore.getUserInfo()
  totalQuota.value = userInfo.totalQuota || 0
  usedQuota.value = userInfo.usedQuota || 0
  percent.value = totalQuota.value > 0 ? Math.floor(usedQuota.value / totalQuota.value * 100) : 0
}

async function fetchFolderList(keepCurrentSelection = false) {
  try {
    const res = await getUserFolderList()
    folderList.value = res.list || []
    
    // 如果不需要保持当前选择，则默认选中第一个有效文件夹并加载文件列表
    if (!keepCurrentSelection) {
      let first = null
      function findFirstValid(node) {
        if (!node) return null
        if (node.id) return node
        if (node.children && node.children.length > 0) {
          for (const child of node.children) {
            const found = findFirstValid(child)
            if (found) return found
          }
        }
        return null
      }
      if (folderList.value.length > 0) {
        for (const node of folderList.value) {
          first = findFirstValid(node)
          if (first) break
        }
        if (first && first.id) {
          selectedNode.value = first
          currentFolderId.value = first.id
          fetchFileList(first.id, 1, pageSize.value)
        }
      }
    }
  } catch (e) {
    folderList.value = []
    fileList.value = []
  }
}

async function fetchFileList(folderId, page = 1, limit = 10) {
  if (!folderId || folderId === 0) {
    fileList.value = []
    total.value = 0
    return
  }
  
  loading.value = true
  // 如果是首次加载（列表为空），显示全屏 loading
  if (fileList.value.length === 0) {
    initialLoading.value = true
  }
  
  try {
    const res = await getFilesByFolder(folderId, page, limit)
    fileList.value = res.list || []
    total.value = res.total || 0
    currentPage.value = page
    
    // 清理不再存在的视频观察
    const currentFileIds = fileList.value
      .filter(file => getFileType(file) === 'video' && file.fileUrl)
      .map(file => file.id)
    cleanupUnusedVideoObservers(currentFileIds)
    
    // 数据加载完成，关闭全屏 loading
    initialLoading.value = false
  } catch (e) {
    fileList.value = []
    total.value = 0
    ElMessage.error('获取文件列表失败')
    initialLoading.value = false
  } finally {
    loading.value = false
    // 确保全屏 loading 已关闭（防止某些情况下未关闭）
    initialLoading.value = false
  }
}

// 新建文件夹弹窗相关
const addDialogVisible = ref(false)
const addForm = ref({
  folderName: '',
  folderSort: 1
})
const addFormLoading = ref(false)
const addFormRules = {
  folderName: [
    { required: true, message: '请输入文件夹名称', trigger: 'blur' }
  ]
}
const addFormRef = ref(null)

function openAddDialog() {
  addForm.value = { folderName: '', folderSort: 1 }
  addDialogVisible.value = true
  // parentId 取当前选中节点
  // 若未选中则为根目录
}

async function handleAddFolder() {
  addFormLoading.value = true
  try {
    await addFormRef.value.validate()
    await addUserFolder({
      folderName: addForm.value.folderName,
      parentId: selectedNode.value ? selectedNode.value.id : 0,
      folderSort: addForm.value.folderSort
    })
    ElMessage.success('新建文件夹成功')
    addDialogVisible.value = false
    fetchFolderList()
  } catch (e) {
    if (e && e.message) ElMessage.error(e.message)
  } finally {
    addFormLoading.value = false
  }
}

const renameDialogVisible = ref(false)
const renameForm = ref({ id: null, fileName: '', targetFolderId: null })
const renameLoading = ref(false)

// 批量移动相关
const batchMoveDialogVisible = ref(false)
const batchMoveForm = ref({ targetFolderId: null })
const batchMoveLoading = ref(false)

function openRenameDialog(file) {
  renameForm.value = { id: file.id, fileName: file.fileName, targetFolderId: currentFolderId.value }
  renameDialogVisible.value = true
}

async function handleRenameFile() {
  renameLoading.value = true
  try {
    // 如果文件名有变化，执行重命名
    if (renameForm.value.fileName && renameForm.value.fileName.trim()) {
      await renameUserFile(renameForm.value.id, renameForm.value.fileName)
    }
    
    // 如果目标文件夹有变化，执行移动
    if (renameForm.value.targetFolderId && renameForm.value.targetFolderId !== currentFolderId.value) {
      await moveUserFile(renameForm.value.id, renameForm.value.targetFolderId)
    }
    
    ElMessage.success('操作成功')
    renameDialogVisible.value = false
    
    // 如果文件被移动到其他文件夹，刷新当前文件夹列表
    if (renameForm.value.targetFolderId && renameForm.value.targetFolderId !== currentFolderId.value) {
      fetchFileList(currentFolderId.value, currentPage.value, pageSize.value)
    } else {
      // 如果只是重命名，刷新当前文件夹列表
      fetchFileList(currentFolderId.value, currentPage.value, pageSize.value)
    }
    
    // 刷新文件夹列表以更新文件夹大小，保持当前选择
    fetchFolderList(true)
  } catch (e) {
    ElMessage.error(e.message || '操作失败')
  } finally {
    renameLoading.value = false
  }
}

async function handleDeleteFile(file) {
  try {
    await ElMessageBox.confirm(`确定要删除文件"${file.fileName}"吗？`, '提示', { type: 'warning' })
    await deleteUserFile(file.id)
    ElMessage.success('删除成功')
    // 刷新文件列表、用户空间信息和文件夹列表，保持当前选择
    fetchFileList(currentFolderId.value, currentPage.value, pageSize.value)
    fetchUserSpace()
    fetchFolderList(true)
  } catch (e) {
    if (e !== 'cancel' && e !== 'close') {
      ElMessage.error(e.message || '删除失败')
    }
  }
}

const multipleSelection = ref([])
const fileTableRef = ref(null)

function handleSelectionChange(val) {
  multipleSelection.value = val
}

// 判断文件是否被选中
function isFileSelected(file) {
  return multipleSelection.value.some(item => item.id === file.id)
}

// 切换文件选择状态
function toggleFileSelection(file, checked) {
  if (checked) {
    if (!isFileSelected(file)) {
      multipleSelection.value.push(file)
    }
  } else {
    const index = multipleSelection.value.findIndex(item => item.id === file.id)
    if (index > -1) {
      multipleSelection.value.splice(index, 1)
    }
  }
}

// 判断是否全选（当前页面的所有文件都被选中）
const isAllSelected = computed(() => {
  if (fileList.value.length === 0) return false
  return fileList.value.every(file => isFileSelected(file))
})

// 处理全选/取消全选
function handleSelectAll(checked) {
  if (checked) {
    // 全选：将当前页面所有未选中的文件添加到选中列表
    fileList.value.forEach(file => {
      if (!isFileSelected(file)) {
        multipleSelection.value.push(file)
      }
    })
  } else {
    // 取消全选：从选中列表中移除当前页面的所有文件
    const currentPageFileIds = fileList.value.map(file => file.id)
    multipleSelection.value = multipleSelection.value.filter(
      file => !currentPageFileIds.includes(file.id)
    )
  }
}

// 判断是否为图片文件
function isImageFile(target) {
  if (!target) return false
  let path = ''
  if (typeof target === 'string') {
    path = target
  } else if (typeof target === 'object') {
    path = target.fileUrl || target.fileName || ''
  }
  if (!path) return false
  const extension = path.toLowerCase().split('.').pop()
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'ico']
  return imageExtensions.includes(extension)
}

// 处理图片加载成功
function handleImageLoad(event) {
  // 图片加载成功，隐藏图标
  const thumbnailDiv = event.target.parentElement
  if (thumbnailDiv) {
    const iconDiv = thumbnailDiv.querySelector('.thumbnail-icon')
    if (iconDiv) {
      iconDiv.style.display = 'none'
    }
  }
}

// 处理图片加载错误
function handleImageError(event) {
  // 隐藏图片，显示图标
  event.target.style.display = 'none'
  // 显示图标
  const thumbnailDiv = event.target.parentElement
  if (thumbnailDiv) {
    const iconDiv = thumbnailDiv.querySelector('.thumbnail-icon')
    if (iconDiv) {
      iconDiv.style.display = 'flex'
    }
  }
}

// 判断是否为根节点
const isRootNode = (data) => {
  // 根节点是 folderList 数组中的直接元素
  // 通过检查节点是否在 folderList 的顶层来判断
  return folderList.value.some(rootNode => rootNode.id === data.id)
}

// 分页事件处理
function handlePageChange(page) {
  currentPage.value = page
  fetchFileList(currentFolderId.value, page, pageSize.value)
}

function handlePageSizeChange(size) {
  const newSize = typeof size === 'string' ? parseInt(size) : size
  pageSize.value = newSize
  currentPage.value = 1
  fetchFileList(currentFolderId.value, 1, newSize)
}

// 批量删除
async function handleBatchDelete() {
  if (multipleSelection.value.length === 0) return
  try {
    await ElMessageBox.confirm(
      `确定要删除选中的${multipleSelection.value.length}个文件吗？`,
      '提示',
      { type: 'warning' }
    )
    const ids = multipleSelection.value.map(f => f.id)
    await batchDeleteUserFiles(ids)
    ElMessage.success('批量删除成功')
    // 刷新文件列表、用户空间信息和文件夹列表，保持当前选择
    fetchFileList(currentFolderId.value, currentPage.value, pageSize.value)
    fetchUserSpace()
    fetchFolderList(true)
    multipleSelection.value = []
  } catch (e) {
    if (e !== 'cancel' && e !== 'close') {
      ElMessage.error(e.message || '批量删除失败')
    }
  }
}

// 批量下载
async function handleBatchDownload() {
  if (multipleSelection.value.length === 0) return
  if (multipleSelection.value.length > 10) {
    ElMessage.warning('最多选择10个任务')
    return
  }
  const ids = multipleSelection.value.map(f => f.id)
  try {
    const res = await batchDownloadUserFiles(ids)
    if (res && res.code === 0 && res.url) {
      // 使用fetch下载文件，确保即使Content-Disposition是inline也能强制下载
      ElMessage.info('正在准备下载...')
      
      const response = await fetch(res.url, {
        method: 'GET',
        headers: {
          'Accept': '*/*'
        }
      })
      
      if (!response.ok) {
        throw new Error(`下载失败: ${response.status} ${response.statusText}`)
      }
      
      // 获取文件blob
      const blob = await response.blob()
      
      // 从URL中提取文件名，如果没有则使用默认名称
      const urlObj = new URL(res.url)
      const pathParts = urlObj.pathname.split('/')
      let fileName = pathParts[pathParts.length - 1] || 'download.zip'
      
      // 如果文件名没有扩展名，尝试从Content-Type推断
      if (!fileName.includes('.')) {
        const contentType = response.headers.get('Content-Type')
        if (contentType) {
          const extension = contentType.split('/')[1]?.split(';')[0]
          if (extension) {
            fileName = `${fileName}.${extension}`
          }
        }
        // 如果还是没有扩展名，默认使用zip
        if (!fileName.includes('.')) {
          fileName = 'download.zip'
        }
      }
      
      // 创建下载链接
      const blobUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = blobUrl
      link.download = fileName
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      
      // 释放blob URL
      window.URL.revokeObjectURL(blobUrl)
      
      ElMessage.success('批量下载已开始')
    } else {
      ElMessage.error(res && res.msg ? res.msg : '批量下载失败')
    }
  } catch (e) {
    console.error('批量下载失败:', e)
    ElMessage.error('批量下载失败: ' + (e.message || '未知错误'))
  }
}

// 打开批量移动对话框
function openBatchMoveDialog() {
  if (multipleSelection.value.length === 0) {
    ElMessage.warning('请先选择要移动的文件')
    return
  }
  batchMoveForm.value = { targetFolderId: currentFolderId.value }
  batchMoveDialogVisible.value = true
}

// 批量移动文件
async function handleBatchMoveFiles() {
  if (!batchMoveForm.value.targetFolderId) {
    ElMessage.warning('请选择目标文件夹')
    return
  }
  
  batchMoveLoading.value = true
  try {
    const fileIds = multipleSelection.value.map(f => f.id)
    await batchMoveUserFiles(fileIds, batchMoveForm.value.targetFolderId)
    ElMessage.success(`成功移动 ${fileIds.length} 个文件`)
    batchMoveDialogVisible.value = false
    
    // 刷新文件列表、用户空间信息和文件夹列表，保持当前选择
    fetchFileList(currentFolderId.value, currentPage.value, pageSize.value)
    fetchUserSpace()
    fetchFolderList(true)
    multipleSelection.value = []
  } catch (e) {
    ElMessage.error(e.message || '批量移动失败')
  } finally {
    batchMoveLoading.value = false
  }
}

  // 单个下载
  async function handleDownloadFile(file) {
    try {
      const res = await downloadUserFile(file.id)
      const url = res.url
      if (!url) {
        ElMessage.error('文件下载地址不存在')
        return
      }
      
      // 使用fetch下载文件，确保即使Content-Disposition是inline也能强制下载
      ElMessage.info('正在准备下载...')
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept': '*/*'
        }
      })
      
      if (!response.ok) {
        throw new Error(`下载失败: ${response.status} ${response.statusText}`)
      }
      
      // 获取文件blob
      const blob = await response.blob()
      
      // 从URL中提取文件名，如果没有则使用file.fileName
      const urlObj = new URL(url)
      const pathParts = urlObj.pathname.split('/')
      let fileName = pathParts[pathParts.length - 1] || file.fileName || 'download'
      
      // 如果文件名没有扩展名，尝试从Content-Type推断
      if (!fileName.includes('.')) {
        const contentType = response.headers.get('Content-Type')
        if (contentType) {
          const extension = contentType.split('/')[1]?.split(';')[0]
          if (extension) {
            fileName = `${fileName}.${extension}`
          }
        }
        // 如果还是没有扩展名，使用file.fileName
        if (!fileName.includes('.') && file.fileName) {
          fileName = file.fileName
        }
      }
      
      // 创建下载链接
      const blobUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = blobUrl
      link.download = fileName
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      
      // 释放blob URL
      window.URL.revokeObjectURL(blobUrl)
      
      ElMessage.success('下载已开始')
    } catch (e) {
      console.error('下载失败:', e)
      ElMessage.error('下载失败: ' + (e.message || '未知错误'))
    }
  }

async function handleCopyUrl(file) {
  try {
    // 检查是否支持现代剪贴板API
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(file.fileUrl)
      ElMessage.success('复制链接成功')
    } else {
      // 降级到传统方法
      const textArea = document.createElement('textarea')
      textArea.value = file.fileUrl
      textArea.style.position = 'fixed'
      textArea.style.left = '-999999px'
      textArea.style.top = '-999999px'
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      
      try {
        const successful = document.execCommand('copy')
        if (successful) {
          ElMessage.success('复制链接成功')
        } else {
          throw new Error('复制失败')
        }
      } catch (err) {
        throw new Error('复制失败，请手动复制')
      } finally {
        document.body.removeChild(textArea)
      }
    }
  } catch (error) {
    console.error('复制链接失败:', error)
    ElMessage.error(error.message || '复制链接失败')
  }
}

// 处理文件sign标识切换（防止7天自动删除）
async function handleSignChange(file, checked) {
  try {
    // 根据开关状态决定发送的sign值：开启时sign=1，关闭时sign=0
    const targetSign = checked ? 1 : 0
    
    // 如果状态没有变化，不需要发送请求
    if (file.sign === targetSign) {
      return
    }
    
    // 发送请求更新sign标识
    const res = await updateFileSign(file.id, targetSign)
    
    // 根据返回的sign_result更新文件状态
    if (res && res.sign_result !== undefined) {
      // 更新文件列表中的sign值
      const fileIndex = fileList.value.findIndex(f => f.id === file.id)
      if (fileIndex > -1) {
        fileList.value[fileIndex].sign = res.sign_result
      }
      // 同时更新原文件对象
      file.sign = res.sign_result
      
      // 根据sign_result显示提示信息
      if (res.sign_result === 1) {
        ElMessage.success('已生效，该文件将不会被7天自动删除')
      } else {
        ElMessage.success('已关闭，该文件将允许7天自动删除')
      }
    } else {
      // 如果没有返回sign_result，根据请求的sign值设置
      const fileIndex = fileList.value.findIndex(f => f.id === file.id)
      if (fileIndex > -1) {
        fileList.value[fileIndex].sign = targetSign
      }
      file.sign = targetSign
      
      if (targetSign === 1) {
        ElMessage.success('已生效，该文件将不会被7天自动删除')
      } else {
        ElMessage.success('已关闭，该文件将允许7天自动删除')
      }
    }
  } catch (error) {
    console.error('更新文件sign标识失败:', error)
    ElMessage.error(error.message || '操作失败')
    // 发生错误时，恢复开关状态到原来的值
    const fileIndex = fileList.value.findIndex(f => f.id === file.id)
    if (fileIndex > -1) {
      // 恢复原来的sign值
      fileList.value[fileIndex] = { ...fileList.value[fileIndex], sign: file.sign || 0 }
    }
  }
}

const uploadDialogVisible = ref(false)
const uploadFileList = ref([])
const uploadLoading = ref(false)
const uploadTargetFolder = ref(null)

function openUploadDialogForNode(nodeData) {
  uploadDialogVisible.value = true
  uploadFileList.value = []
  uploadTargetFolder.value = nodeData
}

async function handleUploadFile() {
  if (!uploadFileList.value.length) {
    ElMessage.warning('请选择文件')
    return
  }
  const folderId = uploadTargetFolder.value ? uploadTargetFolder.value.id : currentFolderId.value
  if (!folderId) {
    ElMessage.warning('请先选择文件夹')
    return
  }
  uploadLoading.value = true
  const formData = new FormData()
  formData.append('file', uploadFileList.value[0].raw)
  formData.append('folderId', folderId)
  try {
    await uploadUserFile(formData)
    ElMessage.success('上传成功')
    uploadDialogVisible.value = false
    // 刷新文件列表、用户空间信息和文件夹列表，保持当前选择
    fetchFileList(folderId, 1, pageSize.value)
    fetchUserSpace()
    fetchFolderList(true)
  } catch (e) {
    ElMessage.error(e.message || '上传失败')
  } finally {
    uploadLoading.value = false
  }
}

const editFolderDialogVisible = ref(false)
const editFolderForm = ref({ id: null, folderName: '' })
const editFolderLoading = ref(false)

// 扩容相关
const expandDialogVisible = ref(false)
const expandForm = ref({
  expandSize: 100,
  expandPrice: 10,
  originalPrice: 10,
  payMethod: 'alipay'
})
const expandFormRules = {
  expandSize: [
    { required: true, message: '请输入扩容容量', trigger: 'blur' },
    { 
      validator: (rule, value, callback) => {
        if (value < 100) {
          callback(new Error('最小扩容容量为100MB'))
        } else if (value % 100 !== 0) {
          callback(new Error('扩容容量必须是100MB的倍数'))
        } else {
          callback()
        }
      }, 
      trigger: 'blur' 
    }
  ],
  payMethod: [
    { required: true, message: '请选择支付方式', trigger: 'change' }
  ]
}
const expandFormRef = ref(null)
const expandLoading = ref(false)

// 支付相关
const showPayModal = ref(false)
const payQRCode = ref('')
const paymentPollingTimer = ref(null)
const currentOrderId = ref(null)
const payMethod = ref('alipay')
const payType = ref('expand') // 'expand' or 'renew'

// 计算有效期（当前时间+一年）
const validityPeriod = computed(() => {
  // 如果用户有VIP到期时间，使用VIP到期时间，否则使用当前时间+一年
  const userInfo = userStore.userInfo
  let expireDate
  
  if (userInfo && userInfo.vipExpireTime) {
    expireDate = new Date(userInfo.vipExpireTime)
  } else {
    const now = new Date()
    expireDate = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate())
  }
  
  return expireDate.toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  })
})

// 计算当前VIP到期时间
const currentVipExpireTime = computed(() => {
  const userInfo = userStore.userInfo
  if (userInfo && userInfo.vipExpireTime) {
    return new Date(userInfo.vipExpireTime).toLocaleDateString('zh-CN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    })
  }
  return 'N/A'
})

// 计算续签后的到期时间
const renewAfterExpireTime = computed(() => {
  const userInfo = userStore.userInfo
  let baseDate
  if (userInfo && userInfo.vipExpireTime) {
    baseDate = new Date(userInfo.vipExpireTime)
  } else {
    baseDate = new Date()
  }
  // 续签年数
  const years = renewForm.value.renewYears || 1
  const newDate = new Date(baseDate.getFullYear() + years, baseDate.getMonth(), baseDate.getDate())
  return newDate.toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  })
})

// 计算折扣后的价格
const calculateDiscountedPrice = (originalPrice) => {
  const userInfo = userStore.userInfo
  if (!userInfo || !userInfo.vipExpireTime) {
    return originalPrice // 没有VIP，原价
  }
  
  const now = new Date()
  const vipExpireTime = new Date(userInfo.vipExpireTime)
  
  // 如果VIP已过期，原价
  if (vipExpireTime <= now) {
    return originalPrice
  }
  
  // 计算VIP剩余天数
  const diffTime = vipExpireTime - now
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
  
  // 根据剩余天数计算折扣
  let discount = 1.0
  if (diffDays >= 365) {
    discount = 0.8 // 剩余1年以上，8折
  } else if (diffDays >= 180) {
    discount = 0.85 // 剩余6个月以上，8.5折
  } else if (diffDays >= 90) {
    discount = 0.9 // 剩余3个月以上，9折
  } else if (diffDays >= 30) {
    discount = 0.95 // 剩余1个月以上，9.5折
  }
  
  return (originalPrice * discount).toFixed(2)
}

// 监听扩容容量变化，自动计算价格
watch(
  () => expandForm.value.expandSize,
  (val) => {
    if (val && val >= 100 && val % 100 === 0) {
      const originalPrice = (val / 100) * 2
      expandForm.value.originalPrice = originalPrice
      expandForm.value.expandPrice = calculateDiscountedPrice(originalPrice)
    }
  },
  { immediate: true }
)

function openExpandDialog() {
  if (blockUnavailablePayment()) return
  expandForm.value = {
    expandSize: 100,
    expandPrice: 10,
    originalPrice: 10,
    payMethod: 'alipay'
  }
  expandDialogVisible.value = true
  // 手动触发价格计算
  const originalPrice = (expandForm.value.expandSize / 100) * 2
  expandForm.value.originalPrice = originalPrice
  expandForm.value.expandPrice = calculateDiscountedPrice(originalPrice)
}

// 先声明renewForm
const renewForm = ref({
  renewYears: 1,
  renewSize: 100,
  renewPrice: 0,
  originalPrice: 0,
  payMethod: 'alipay'
})

// 再写watch
watch(
  [() => renewForm.value.renewYears, () => renewForm.value.renewSize],
  ([years, size]) => {
    if (
      years && years >= 1 && years <= 10 &&
      size && size >= 100 && size <= totalQuota.value
    ) {
      const yearPrice = (size - 100) / 10
      const originalTotal = yearPrice * years
      let discount = 1
      if (years === 1) discount = 1
      else if (years === 2) discount = 0.9
      else if (years === 3) discount = 0.8
      else if (years === 4) discount = 0.7
      else if (years >= 5) discount = 0.6
      renewForm.value.originalPrice = originalTotal
      renewForm.value.renewPrice = (originalTotal * discount).toFixed(2)
    }
  },
  { immediate: true }
)

function stopPaymentPolling() {
  if (paymentPollingTimer.value) {
    clearInterval(paymentPollingTimer.value)
    paymentPollingTimer.value = null
  }
}

async function checkPaymentStatus() {
  if (!currentOrderId.value) return
  let res
  if (payMethod.value === 'wechat') {
    res = await queryWxPayOrder(currentOrderId.value)
    const { tradeState } = res.msg || {}
    if (tradeState === 'SUCCESS') {
      stopPaymentPolling()
      showPayModal.value = false
      ElMessage.success('支付成功')
      fetchUserSpace() // 刷新用户空间信息
      expandDialogVisible.value = false
    }
  } else if (payMethod.value === 'alipay') {
    res = await queryAlipayOrder(currentOrderId.value)
    const { data } = res
    if (data && (data.payStatus === 'PAID' || data.payStatus === 'COMPLETED' || data.payInfoStatus === 'TRADE_SUCCESS')) {
      stopPaymentPolling()
      showPayModal.value = false
      ElMessage.success('支付成功')
      fetchUserSpace() // 刷新用户空间信息
      expandDialogVisible.value = false
    }
  }
}

function startPaymentPolling() {
  stopPaymentPolling()
  paymentPollingTimer.value = setInterval(() => {
    checkPaymentStatus()
  }, 3000)
}

async function handleRenewConfirm() {
  if (blockUnavailablePayment()) return
  payType.value = 'renew'
  renewLoading.value = true
  try {
    await renewFormRef.value.validate()
    
    const renewPrice = (renewForm.value.renewSize - 100) / 10 * renewForm.value.renewYears
    renewForm.value.renewPrice = renewPrice
    renewForm.value.originalPrice = (renewForm.value.renewSize - 100) / 10

    payMethod.value = renewForm.value.payMethod
    // 创建续签订单
    const orderParams = {
      renewYears: renewForm.value.renewYears,
      renewSize: renewForm.value.renewSize,
      amount: renewForm.value.renewPrice,
      payType: renewForm.value.payMethod
    }
    
    const res = await createRenewOrder(orderParams) // 续签订单接口
    if (res.code !== 0 || !res.orderId) {
      ElMessage.error(res.message || '创建订单失败')
      return
    }
    
    currentOrderId.value = res.orderId
    
    if (renewForm.value.payMethod === 'wechat') {
      const wxRes = await getWxPayParams(res.orderId)
      if (wxRes.code === 0 && wxRes.code_url) {
        payQRCode.value = await QRCode.toDataURL(wxRes.code_url, { width: 200 })
        showPayModal.value = true
        startPaymentPolling()
      } else {
        ElMessage.error(wxRes.msg || '获取微信二维码失败')
      }
    } else if (renewForm.value.payMethod === 'alipay') {
      const aliRes = await getAlipayParams(res.orderId)
      const formHtml = aliRes.data?.qrCode || aliRes.msg
      if (aliRes.code === 0 && formHtml) {
        const tempDiv = document.createElement('div')
        tempDiv.id = 'alipay-temp-form-div'
        tempDiv.style.display = 'none'
        tempDiv.innerHTML = formHtml
        document.body.appendChild(tempDiv)
        const form = tempDiv.querySelector('form')
        if (form) {
          form.method = 'post'
          form.target = '_blank'
          form.submit()
          setTimeout(() => {
            if (tempDiv.parentNode) document.body.removeChild(tempDiv)
          }, 2000)
          startPaymentPolling()
        } else {
          ElMessage.error('支付宝表单异常')
        }
      } else {
        ElMessage.error(aliRes.message || '获取支付宝支付信息失败')
      }
    }
  } catch (e) {
    ElMessage.error(e.message || '续签发起失败')
  } finally {
    renewLoading.value = false
  }
}

async function handleExpandConfirm() {
  if (blockUnavailablePayment()) return
  payType.value = 'expand'
  try {
    await expandFormRef.value.validate()
    
    expandLoading.value = true
    payMethod.value = expandForm.value.payMethod
    
    // 创建扩容订单
    const orderParams = {
      expandSize: expandForm.value.expandSize,
      amount: expandForm.value.expandPrice,
      payType: expandForm.value.payMethod
    }
    
    const res = await createExpandOrder(orderParams)
    if (res.code !== 0 || !res.orderId) {
      ElMessage.error(res.message || '创建订单失败')
      return
    }
    
    currentOrderId.value = res.orderId
    
    if (expandForm.value.payMethod === 'wechat') {
      const wxRes = await getWxPayParams(res.orderId)
      if (wxRes.code === 0 && wxRes.code_url) {
        payQRCode.value = await QRCode.toDataURL(wxRes.code_url, { width: 200 })
        showPayModal.value = true
        startPaymentPolling()
      } else {
        ElMessage.error(wxRes.msg || '获取微信二维码失败')
      }
    } else if (expandForm.value.payMethod === 'alipay') {
      const aliRes = await getAlipayParams(res.orderId)
      const formHtml = aliRes.data?.qrCode || aliRes.msg
      if (aliRes.code === 0 && formHtml) {
        const tempDiv = document.createElement('div')
        tempDiv.id = 'alipay-temp-form-div'
        tempDiv.style.display = 'none'
        tempDiv.innerHTML = formHtml
        document.body.appendChild(tempDiv)
        const form = tempDiv.querySelector('form')
        if (form) {
          form.method = 'post'
          form.target = '_blank'
          form.submit()
          setTimeout(() => {
            if (tempDiv.parentNode) document.body.removeChild(tempDiv)
          }, 2000)
          startPaymentPolling()
        } else {
          ElMessage.error('支付宝表单异常')
        }
      } else {
        ElMessage.error(aliRes.message || '获取支付宝支付信息失败')
      }
    }
  } catch (e) {
    ElMessage.error(e.message || '支付发起失败')
  } finally {
    expandLoading.value = false
  }
}

function openEditFolderDialog(nodeData) {
  editFolderForm.value = { id: nodeData.id, folderName: nodeData.folderName }
  editFolderDialogVisible.value = true
}

async function handleEditFolder() {
  editFolderLoading.value = true
  try {
    await renameUserFolder(editFolderForm.value.id, editFolderForm.value.folderName)
    ElMessage.success('修改成功')
    editFolderDialogVisible.value = false
    fetchFolderList()
  } catch (e) {
    ElMessage.error(e.message || '修改失败')
  } finally {
    editFolderLoading.value = false
  }
}

// 续签相关
const renewDialogVisible = ref(false)
const renewLoading = ref(false)
const renewFormRules = {
  renewYears: [
    { required: true, message: '请选择续签时长', trigger: 'change' },
    { type: 'number', min: 1, max: 10, message: '续签时长必须为1-10年', trigger: 'change' }
  ],
  payMethod: [
    { required: true, message: '请选择支付方式', trigger: 'change' }
  ]
}
const renewFormRef = ref(null)

// 文件类型检测和预览相关
const previewDialogVisible = ref(false)
const previewFile = ref(null)
const previewType = ref('') // 'audio' | 'video'

// 文件类型检测函数
function getFileType(target) {
  if (!target) return 'other'
  let path = ''
  if (typeof target === 'string') {
    path = target
  } else if (typeof target === 'object') {
    path = target.fileUrl || target.fileName || ''
  }
  if (!path) return 'other'

  const extension = path.toLowerCase().split('.').pop()
  
  // 音频文件扩展名
  const audioExtensions = ['mp3', 'wav', 'flac', 'aac', 'ogg', 'm4a', 'wma', 'opus']
  // 视频文件扩展名
  const videoExtensions = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mkv', 'm4v', '3gp', 'ogv']
  
  if (audioExtensions.includes(extension)) {
    return 'audio'
  } else if (videoExtensions.includes(extension)) {
    return 'video'
  } else {
    return 'other'
  }
}

// 获取文件类型 Font Awesome 图标类名
function getFileIconClass(target) {
  const fileType = getFileType(target)
  switch (fileType) {
    case 'audio':
      return 'fa-solid fa-music'
    case 'video':
      return 'fa-solid fa-video'
    default:
      return 'fa-regular fa-file'
  }
}

// 打开预览
function openPreview(file) {
  const fileType = getFileType(file)
  if (fileType === 'audio' || fileType === 'video') {
    previewFile.value = file
    previewType.value = fileType
    previewDialogVisible.value = true
  }
}

// 处理缩略图点击
function handleThumbnailClick(file) {
  const fileType = getFileType(file)
  // 如果是图片，可以在这里添加图片预览逻辑
  // 如果是音频或视频，打开预览
  if (fileType === 'audio' || fileType === 'video') {
    openPreview(file)
  } else if (isImageFile(file) && file.fileUrl) {
    // 图片预览可以在这里实现，或者直接打开预览对话框
    // 暂时先不做处理，或者可以添加图片预览功能
  }
}

function openRenewDialog() {
  if (blockUnavailablePayment()) return
  const currentTotalQuota = userStore.userInfo?.totalQuota || 0
  renewForm.value = {
    renewYears: 1,
    renewSize: currentTotalQuota,
    renewPrice: 0,
    originalPrice: 0,
    payMethod: 'alipay'
  }
  renewDialogVisible.value = true
  // 计算初始费用
  const yearPrice = (renewForm.value.renewSize - 100) / 10
  renewForm.value.originalPrice = yearPrice
  renewForm.value.renewPrice = yearPrice * renewForm.value.renewYears
}

// 监听支付弹窗关闭，自动停止轮询
watch(
  () => showPayModal.value,
  (val) => {
    if (!val) stopPaymentPolling()
  }
)

onMounted(() => {
  // 设置页面标题
  document.title = '云盘空间'
  // 初始化视频 Observer
  initVideoObserver()
  
  fetchUserSpace()
  fetchFolderList()
  document.addEventListener('click', handleClickOutsideMenu)
})

// 清理事件
onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutsideMenu)
  stopPaymentPolling()
  // 清理视频 Observer
  cleanupVideoObserver()
})
</script>

<style scoped>
.cloud-container {
  flex: 1;
  display: flex;
  overflow: hidden;
}

.storage-panel {
  width: 210px;
  background: #F9FAFB;
  border-right: 1px solid #E5E7EB;
  padding: 24px;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  overflow-y: auto;
}

.file-browser {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
  overflow: hidden;
}

.browser-toolbar {
  padding: 16px 24px;
  border-bottom: 1px solid #F3F4F6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}

.toolbar-left {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 14px;
  color: #6B7280;
}

.toolbar-right {
  display: flex;
  gap: 10px;
}

.file-grid-scroll {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
}

.empty-file-list {
  color: #6B7280;
  padding: 80px 32px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}

.empty-file-list .empty-text {
  margin-top: 16px;
  font-size: 16px;
  color: #9CA3AF;
}
.local-space {
  width: 100%;
  height: 100%;
  background: #F3F4F6;
  color: #1F2937;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.notice-bar {
  background: #FFFBEB;
  border-bottom: 1px solid #FCD34D;
  color: #92400E;
  padding: 10px 20px;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.notice-icon {
  color: #F59E0B;
  flex-shrink: 0;
}

.storage-status {
  margin-bottom: 30px;
}

.storage-text {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #6B7280;
  margin-bottom: 8px;
}

.storage-text strong {
  color: #1F2937;
}

.progress-track {
  height: 6px;
  background: #E5E7EB;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 12px;
}

.progress-fill {
  height: 100%;
  background: #4F46E5;
  border-radius: 10px;
  transition: width 0.3s;
}

.storage-actions {
  display: flex;
  gap: 10px;
}

.action-link {
  font-size: 12px;
  color: #10B981;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 4px;
}

.action-link:hover {
  text-decoration: underline;
}

.folder-list {
  margin-top: 10px;
  flex: 1;
  overflow-y: auto;
}

.empty-folder {
  width: 100%;
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #9CA3AF;
}

.empty-text {
  font-size: 18px;
  color: #9CA3AF;
  margin-top: 16px;
}
.context-menu {
  background: #fff;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  min-width: 120px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.context-menu-item {
  padding: 8px 16px;
  cursor: pointer;
  color: #1F2937;
}

.context-menu-item:hover {
  background: #F3F4F6;
}

/* 文件夹悬浮操作菜单 */
.folder-hover-menu {
  background: #fff;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 4px;
  min-width: 100px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.hover-menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  cursor: pointer;
  color: #1F2937;
  font-size: 13px;
  border-radius: 4px;
  transition: all 0.2s;
}

.hover-menu-item:hover {
  background: #F3F4F6;
  color: #4F46E5;
}

.hover-menu-item i {
  font-size: 14px;
  width: 16px;
  text-align: center;
}

.hover-menu-item span {
  flex: 1;
}

/* 扩容弹窗样式 */
.expand-content {
  padding: 20px 0;
}
.expand-info {
  margin-bottom: 20px;
}
.current-space {
  background: #f5f5f5;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 16px;
  color: #333;
}
.expand-input-area {
  margin-top: 16px;
}
.expand-tip {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.expand-price {
  font-size: 18px;
  font-weight: bold;
  color: #ff6b6b;
}
.validity-period {
  background: #f5f5f5;
  padding: 12px;
  border-radius: 4px;
  margin-top: 16px;
  color: #333;
}
.price-display {
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
}
.original-price {
  font-size: 14px;
  color: #999;
  text-decoration: line-through;
}

/* 续签弹窗样式 */
.renew-content {
  padding: 20px 0;
}
.renew-info {
  margin-bottom: 20px;
}
.current-vip {
  background: #f5f5f5;
  padding: 12px;
  border-radius: 4px;
  margin-top: 16px;
  color: #333;
}
.renew-input-area {
  margin-top: 16px;
}
.renew-tip {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.renew-price {
  font-size: 18px;
  font-weight: bold;
  color: #ff6b6b;
}

/* 支付弹窗样式 */
.pay-modal {
  text-align: center;
  color: #fff;
}
.pay-order {
  margin-bottom: 20px;
}
.pay-qrcode {
  width: 200px;
  height: 200px;
  margin: 0 auto 20px;
  display: block;
}
.pay-info {
  text-align: left;
  margin-bottom: 16px;
}
.pay-info > div {
  margin-bottom: 8px;
  font-size: 14px;
}
.pay-amount {
  font-size: 16px;
  font-weight: bold;
  margin-top: 12px;
}
.pay-tip {
  font-size: 12px;
  color: #ccc;
  text-align: center;
  margin-top: 16px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

/* 文件卡片网格布局 */
.file-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 20px;
  padding: 16px;
}

/* 文件卡片设计 */
.file-card {
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  transition: all 0.2s;
  position: relative;
}

.file-card:hover {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
  border-color: #4F46E5;
}

.file-card-selected {
  border-color: #4F46E5;
  background: #EEF2FF;
}

/* 卡片顶部：预览区 */
.file-preview {
  height: 140px;
  background: #F3F4F6;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

/* 模拟图片/视频背景 */
.file-preview img { 
  width: 100%; 
  height: 100%; 
  object-fit: cover; 
}

.file-preview video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.file-preview.placeholder { 
  background: linear-gradient(135deg, #E0E7FF 0%, #EEF2FF 100%); 
}

.file-preview.placeholder.audio { 
  background: linear-gradient(135deg, #FFF7ED 0%, #FFEDD5 100%); 
}

/* 预览区遮罩组件 */
.card-checkbox {
  position: absolute; 
  top: 10px; 
  left: 10px; 
  z-index: 5;
  width: 18px; 
  height: 18px; 
  cursor: pointer;
}

.download-overlay {
  position: absolute; 
  top: 10px; 
  right: 10px; 
  z-index: 5;
  color:var(--accent-blue); 
  background: rgba(255, 255, 255, 0.8); 
  border-radius: 50%;
  width: 28px; 
  height: 28px; 
  display: flex; 
  align-items: center; 
  justify-content: center;
  backdrop-filter: blur(2px); 
  opacity: 0; 
  transition: 0.2s; 
  cursor: pointer;
}

.play-overlay {
  position: absolute; 
  z-index: 4;
  color: white; 
  font-size: 40px; 
  opacity: 0.8; 
  text-shadow: 0 2px 4px rgba(0,0,0,0.2);
  transition: 0.2s;
  cursor: pointer;
}

.file-card:hover .download-overlay { 
  opacity: 1; 
}

.file-card:hover .play-overlay { 
  transform: scale(1.1); 
}

/* 卡片信息区 */
.file-info { 
  padding: 12px; 
}

.file-name {
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #1F2937;
  margin-bottom: 8px;
  white-space: nowrap; 
  overflow: hidden; 
  text-overflow: ellipsis;
  display: flex; 
  align-items: center; 
  gap: 6px;
}

.meta-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.meta-item {
  font-size: 11px;
  color: #6B7280;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* 卡片底部操作栏 */
.card-actions {
  padding: 8px 12px;
  border-top: 1px solid #F3F4F6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.action-group { 
  display: flex; 
  gap: 12px; 
}

.icon-btn { 
  color: #9CA3AF; 
  font-size: 13px; 
  cursor: pointer; 
  transition: 0.2s; 
}

.icon-btn:hover { 
  color: #4F46E5; 
}

.icon-btn.delete:hover { 
  color: #EF4444; 
}

/* 开关Toggle */
.toggle-switch {
  width: 30px; 
  height: 16px; 
  background: #E5E7EB; 
  border-radius: 20px;
  position: relative; 
  cursor: pointer; 
  transition: 0.3s;
}

.toggle-switch::after {
  content: ''; 
  position: absolute; 
  top: 2px; 
  left: 2px;
  width: 12px; 
  height: 12px; 
  background: white; 
  border-radius: 50%;
  transition: 0.3s; 
  box-shadow: 0 1px 2px rgba(0,0,0,0.2);
}

.toggle-switch.active { 
  background: #4F46E5; 
}

.toggle-switch.active::after { 
  left: 16px; 
}

.drop-target-tree {
  min-height: auto;
}

.folder-tree-node {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-width: 0;
  pointer-events: auto;
}

.folder-tree-icon {
  flex-shrink: 0;
  font-size: 16px;
}

.folder-tree-details {
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
  line-height: 1.2;
}

.folder-tree-name {
  overflow: hidden;
  color: inherit;
  font-size: 13px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.folder-tree-size {
  color: #6B7280;
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
}

.drop-target-tree :deep(.el-tree-node__content) {
  transition: background-color 0.2s ease;
  margin-bottom: 4px;
  padding: 10px 12px;
  border-radius: 8px;
  color: #1F2937;
}

.drop-target-tree :deep(.el-tree-node__content:hover) {
  background-color: #F3F4F6;
}

.drop-target-tree :deep(.el-tree-node.is-current > .el-tree-node__content) {
  background-color: #E0E7FF;
  color: #4F46E5;
  font-weight: 600;
}

.drop-target-tree :deep(.el-tree-node.is-current > .el-tree-node__content .fa-folder),
.drop-target-tree :deep(.el-tree-node.is-current > .el-tree-node__content .fa-folder-open) {
  color: #4F46E5;
}

.drop-target-tree :deep(.el-tree-node__content) {
  min-height: 52px;
  display: flex;
  align-items: center;
}

/* 文件预览弹窗样式 */
.preview-content {
  text-align: center;
}

.preview-info {
  margin-bottom: 16px;
  text-align: left;
}

.file-name {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
}

.file-size {
  font-size: 14px;
  color: #666;
}

.audio-preview,
.video-preview {
  width: 100%;
}

.audio-preview audio,
.video-preview video {
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 骨架屏样式 */
.skeleton-card {
  min-height: 360px;
}

.skeleton-thumbnail {
  width: 100%;
  height: 140px;
  background: #F3F4F6;
  border-radius: 4px;
  margin-bottom: 16px;
}

.skeleton-content {
  padding: 0 12px;
  margin-bottom: 16px;
}

.skeleton-actions {
  display: flex;
  justify-content: center;
  gap: 4px;
  padding: 8px 12px;
  border-top: 1px solid #F3F4F6;
}
</style>
